import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';

const AmazonCreateListing = lazy(() => import('../components/amazon/create-listing/AmazonCreateListing'));
const SellerSnapPage = lazy(() => import('../components/sellersnap'));
const AmazonRestock = lazy(() => import('../components/amazon/restock'));
const AmazonShipments = lazy(() => import('../components/amazon/shipments'));
const AmazonShipmentCapture = lazy(() => import('../components/amazon/shipments/capture'));
const AmazonShipmentDetail = lazy(() => import('../components/amazon/shipments/ShipmentDetail'));
const AmazonSettings = lazy(() => import('../components/amazon/settings'));
const AmazonLeadTimes = lazy(() => import('../components/amazon/settings/lead-times'));
const PipelinePage = lazy(() => import('../components/amazon/pipeline'));
const FBAAdvisor = lazy(() => import('../components/fba-advisor'));
const WholesaleFba = lazy(() => import('../components/wholesale-fba'));
const WarehouseFba = lazy(() => import('../components/warehouse-fba'));
const RestockAlerts = lazy(() => import('../components/restock/RestockAlerts'));

export const amazonRoutes = (
  <>
    <Route path="/amazon/create-listing" element={<AmazonCreateListing />} />
    <Route path="/sellersnap" element={<SellerSnapPage />} />
    <Route path="/amazon/sellersnap" element={<SellerSnapPage />} />
    <Route path="/wholesale-fba" element={<WholesaleFba />} />
    <Route path="/amazon/wholesale-fba" element={<WholesaleFba />} />
    <Route path="/amazon/warehouse-fba" element={<WarehouseFba />} />
    <Route path="/send-to-amazon" element={<Navigate to="/amazon/restock" replace />} />
    <Route path="/send-to-amazon/legacy" element={<Navigate to="/amazon/restock" replace />} />
    <Route path="/amazon/restock" element={<AmazonRestock />} />
    <Route path="/amazon/pipeline" element={<PipelinePage />} />
    <Route path="/amazon/shipments" element={<AmazonShipments />} />
    <Route path="/amazon/shipments/capture" element={<AmazonShipmentCapture />} />
    <Route path="/amazon/shipments/:id" element={<AmazonShipmentDetail />} />
    <Route path="/amazon/settings" element={<AmazonSettings />} />
    <Route path="/amazon/settings/lead-times" element={<AmazonLeadTimes />} />
    <Route path="/fba-advisor" element={<FBAAdvisor />} />
    <Route path="/amazon/advisor" element={<FBAAdvisor />} />
    <Route path="/restock-alerts" element={<RestockAlerts />} />
    <Route path="/amazon/alerts" element={<RestockAlerts />} />
    <Route path="/amazon" element={<Navigate to="/analytics/amazon" replace />} />
    <Route path="/amazon/inventory" element={<Navigate to="/inventory" replace />} />
    <Route path="/amazon/inbound" element={<Navigate to="/analytics/amazon" replace />} />
    <Route path="/amazon/orders" element={<Navigate to="/analytics/amazon" replace />} />
    <Route path="/amazon/profitability" element={<Navigate to="/analytics/amazon" replace />} />
    <Route path="/amazon/fees" element={<Navigate to="/analytics/amazon/fees" replace />} />
    <Route path="/amazon/stranded" element={<Navigate to="/analytics/amazon" replace />} />
    <Route path="/amazon/inventory-age" element={<Navigate to="/analytics/amazon/fba-age" replace />} />
  </>
);
